import { useEffect, useRef, useState } from "react";
var useOffsetTop = function () {
    var ref = useRef(null);
    var _a = useState(), offsetTop = _a[0], setOffsetTop = _a[1];
    useEffect(function () {
        setTimeout(function () {
            setOffsetTop(ref.current.offsetTop);
        }, 400);
    }, []);
    return [ref, offsetTop];
};
export default useOffsetTop;
